var utils = require('../../utils')
import AppHeader from '../AppHeader'

export default {
  name: 'domain-edit',
  created () {
    this.search()
  },
  data () {
    return {
      canValidate: true,
      domain: {
        domain_name: null,
        domain_content: null,
      }
    }
  },
  computed: {
    domains () {
      return this.$store.getters.domain
    },
    loading () {
      return this.$store.getters.apiLoading
    },
    validation: function() {
      var v = {
        domain_name: !!this.domains.data.attributes['domain-name'],
        domain_content: !!this.domains.data.attributes['domain-content'],
        not_input: !!this.domains.data.attributes['domain-name'] && !!this.domains.data.attributes['domain-content']
      }
      if (!this.canValidate) {
        Object.keys(v).forEach(key => { v[key] = true; });
      }
      return v
    },
    isValid () {
      var validation = this.validation
      return Object.keys(validation).every(function (key) {
        return validation[key]
      })
    }
  },
  components: {
    AppHeader
  },
  methods: {
    onClickSave: function () {
      this.canValidate = true
      if (this.isValid) {
        console.log("is valid")
        var data = {
          domain_name: this.domains.data.attributes['domain-name'],
          domain_content: this.domains.data.attributes['domain-content']
        }
        this.$store.dispatch('DOMAIN_UPDATE', { id: this.$route.params.id, data: data, callback: this.onSaved })
      }else{
        console.log("need edit")
      }
    },
    onClickCancel: function () {
      this.$router.push({ path: '/domains', query: { type: this.$router.currentRoute.query.type}})
    },
    search: function() {
      var data = {}
      var self = this
      data.callback = function () {
      }
      this.$store.dispatch('DOMAIN_EDIT',  {id: this.$route.params.id, data: data})
    },
    onSaved: function (result) {
      this.$router.push({ path: '/domains/'})
    },
    halfName: function () {
      this.domains.data.attributes['domain-name'] = utils.emHalf(this.domains.data.attributes['domain-name'])
    },
    halfContent: function () {
      this.domains.data.attributes['domain-content'] = utils.emHalf(this.domains.data.attributes['domain-content'])
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/domain-edit.js